"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUS = exports.getEnvelopeAddressHTML = exports.addressRuleSet = exports.addressDataRuleSet = exports.envelopeAddressRuleSet = exports.ADDRESS_TYPES = void 0;
exports.isEnvelopeAddress = isEnvelopeAddress;
exports.isAddressData = isAddressData;
exports.isAddress = isAddress;
const html_1 = require("../helpers/html");
const uuid_1 = require("../utils/uuid");
const typeguard_1 = require("../types/typeguard");
exports.ADDRESS_TYPES = ['customer', 'friend', 'family', 'other'];
exports.envelopeAddressRuleSet = {
  name: typeguard_1.isNonEmptyString,
  street1: typeguard_1.isNonEmptyString,
  street2: (0, typeguard_1.optional)(typeguard_1.isString),
  city: typeguard_1.isNonEmptyString,
  postalCode: typeguard_1.isNonEmptyString,
  region: (0, typeguard_1.optional)(typeguard_1.isString),
  country: (0, typeguard_1.optional)(typeguard_1.isString)
};
function isEnvelopeAddress(obj) {
  return (0, typeguard_1.isType)(obj, exports.envelopeAddressRuleSet);
}
exports.addressDataRuleSet = {
  name: typeguard_1.isNonEmptyString,
  line1: typeguard_1.isNonEmptyString,
  line2: (0, typeguard_1.optional)(typeguard_1.isString),
  line3: (0, typeguard_1.optional)(typeguard_1.isString),
  city: typeguard_1.isNonEmptyString,
  postalCode: typeguard_1.isNonEmptyString,
  region: (0, typeguard_1.optional)(typeguard_1.isString),
  country: typeguard_1.isNonEmptyString,
  phone: (0, typeguard_1.optional)(typeguard_1.isString),
  groupIds: typeguard_1.isStringArray,
  markedAsDeleted: (0, typeguard_1.optional)(value => typeof value === 'boolean')
};
function isAddressData(obj) {
  return (0, typeguard_1.isType)(obj, exports.addressDataRuleSet);
}
exports.addressRuleSet = Object.assign({
  id: uuid_1.isUUID,
  createdBy: uuid_1.isUUID,
  createdAt: value => value instanceof Date,
  lastModifiedAt: value => value instanceof Date,
  type: (0, typeguard_1.optional)(value => (0, typeguard_1.isString)(value) && ['customer', 'friend', 'family', 'other'].includes(value))
}, exports.addressDataRuleSet);
function isAddress(obj) {
  return (0, typeguard_1.isType)(obj, exports.addressRuleSet);
}
const getEnvelopeAddressHTML = (envelopeAddress, style) => {
  const cleanAddress = {
    name: (0, html_1.removeHtml)(envelopeAddress.name),
    street1: (0, html_1.removeHtml)(envelopeAddress.street1),
    street2: (envelopeAddress === null || envelopeAddress === void 0 ? void 0 : envelopeAddress.street2) && (0, html_1.removeHtml)(envelopeAddress === null || envelopeAddress === void 0 ? void 0 : envelopeAddress.street2),
    city: (0, html_1.removeHtml)(envelopeAddress.city),
    region: (0, html_1.removeHtml)(envelopeAddress.region),
    postalCode: (0, html_1.removeHtml)(envelopeAddress.postalCode),
    country: (0, html_1.removeHtml)(envelopeAddress.country || '')
  };
  function createCss(style) {
    const fontSizeCss = !style.fontSize ? '' : ` font-size: ${(0, html_1.removeHtml)(style.fontSize)}px; `;
    const textAlignCss = !style.textAlign ? '' : `text-align: ${(0, html_1.removeHtml)(style.textAlign)};`;
    const fontFamilyCss = !style.fontFamily ? '' : `font-family: ${(0, html_1.removeHtml)(style.fontFamily)};`;
    return `width: 100%; max-height: 100%; ${fontFamilyCss} ${fontSizeCss} ${textAlignCss}`;
  }
  const htmlString = `
    <div class="address-container" style="${createCss(style)}">
      <div>${cleanAddress.name}</div>
      <div>${cleanAddress.street1}</div>
      ${!cleanAddress.street2 ? '' : `<div>${cleanAddress.street2}</div>`}
      <div>${cleanAddress.city}, ${cleanAddress.region} ${cleanAddress.postalCode}</div>
      ${(0, exports.isUS)(cleanAddress.country) ? '' : `<div>${cleanAddress.country}</div>`}
    </div>`;
  return htmlString;
};
exports.getEnvelopeAddressHTML = getEnvelopeAddressHTML;
const isUS = country => {
  return ['US', 'USA', 'United States', 'United States of America'].includes(country);
};
exports.isUS = isUS;